window.addEventListener("FormClientRendered", () => {
    const questionnaireHeader = document.querySelector(".QuestionnaireHeader");
    const healthBanner = document.querySelector(".fpq__health-banner");

    if (questionnaireHeader && healthBanner) {
        questionnaireHeader.parentNode.insertBefore(healthBanner, questionnaireHeader.nextSibling);
    }
});